import React from "react";

const Page404 = () => {
  return (
    <div className="d-flex p-5 my-5 align-items-center justify-content-center">
      <h4 className="mb-0 fw-bold">Page404</h4>
    </div>
  );
};

export default Page404;
